import { Component, EventEmitter, Output } from '@angular/core';

import {
    ZtFilterChangeEvent,
    ZtFilterEventType,
} from '../zt-filter/zt-filter.model';

@Component({
    selector: 'zt-date-filter',
    templateUrl: 'zt-date-filter.component.html',
    styleUrls: ['zt-date-filter.component.scss'],
})
export class ZtDateFilterComponent {
    @Output() filterChange = new EventEmitter<ZtFilterChangeEvent>();

    readonly dateFormat: string = 'dd.mm.yy';

    date: string = '';

    constructor() {}

    onChange(newValue: any): void {
        if (newValue === null) {
            this.filterChange.emit({
                type: ZtFilterEventType.ALL_MATCH,
            } as ZtFilterChangeEvent);

            return;
        }

        this.filterChange.emit({
            type: ZtFilterEventType.MATCH,
            data: newValue,
        } as ZtFilterChangeEvent);
    }
}
